"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WrapperChooser = exports.ROUTES = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _nuiShell = require("@concur/nui-shell");
var _Errors = require("@concur/nui-shell/lib/components/Errors");
var _appcenterWrapperCom = _interopRequireDefault(require("@concur/appcenter-wrapper-com"));
var _nuiIntlRuntime = _interopRequireWildcard(require("@concur/nui-intl-runtime"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _App = _interopRequireDefault(require("./App"));
var _listings = _interopRequireDefault(require("../listings"));
var _listing = _interopRequireDefault(require("../listing"));
var _SearchContainer = _interopRequireDefault(require("../search/SearchContainer"));
var _TermsPage = _interopRequireDefault(require("../terms/TermsPage"));
var _withRouter = require("../HOCs/withRouter");
var _utils = require("../utils");
var _HelpContainer = _interopRequireDefault(require("../help/HelpContainer"));
var _CookieConsent = _interopRequireDefault(require("../cookieConsent/CookieConsent"));
var _config = _interopRequireDefault(require("../config"));
var _Header = _interopRequireDefault(require("../shared/Header"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ROUTES = exports.ROUTES = {
  US_PUBLIC: '/app-center',
  EU_PUBLIC: '/app-centre'
};

// silly little thing to let us use the in-product or public header and footer
var WrapperChooser = exports.WrapperChooser = /*#__PURE__*/function (_React$Component) {
  function WrapperChooser() {
    _classCallCheck(this, WrapperChooser);
    return _callSuper(this, WrapperChooser, arguments);
  }
  _inherits(WrapperChooser, _React$Component);
  return _createClass(WrapperChooser, [{
    key: "render",
    value: function render() {
      var usePublicWrapper = (0, _utils.isPublic)(this.props.location.pathname);
      if (usePublicWrapper) {
        var nuiLangToUse = (0, _utils.getNuiLanguage)(this.props.meta.originalhost);
        var publicLangToUse = (0, _utils.mapCountryToPublicLang)(this.props.meta.country || 'US');
        var localeData = (0, _nuiIntlRuntime.getLocaleData)(this.props);
        localeData.lang = nuiLangToUse;
        // eslint-disable-next-line import/no-dynamic-require, global-require
        var translations = window.NUI_TRANSLATIONS;
        return /*#__PURE__*/_react.default.createElement(_appcenterWrapperCom.default, {
          lang: publicLangToUse,
          drupalData: this.props.meta.publicMenuData
        }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.default, {
          messages: translations,
          localeData: localeData
        }, /*#__PURE__*/_react.default.createElement(_reactRouter.Outlet, null)));
      }
      return (
        /*#__PURE__*/
        // NuiPageContainer has built-in <Outlet /> Component
        _react.default.createElement(_nuiShell.NuiPageContainer, null, this.props.meta.listingNotFound && /*#__PURE__*/_react.default.createElement(_Errors.NotFound, null))
      );
    }
  }]);
}(_react.default.Component);
WrapperChooser.propTypes = {
  location: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  meta: _propTypes.default.shape({
    originalhost: _propTypes.default.string,
    country: _propTypes.default.string,
    listingFound: _propTypes.default.bool,
    publicMenuData: _propTypes.default.object
  })
};
var NavigateToNewListing = function NavigateToNewListing(_ref) {
  var baseUrl = _ref.baseUrl;
  var _useParams = (0, _reactRouter.useParams)(),
    id = _useParams.id;
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Navigate, {
    replace: true,
    to: "".concat(baseUrl, "/listings/").concat(id)
  });
};
NavigateToNewListing.propTypes = {
  baseUrl: _propTypes.default.string
};
var NavigateToListingsWithNewFilter = function NavigateToListingsWithNewFilter(_ref2) {
  var baseUrl = _ref2.baseUrl;
  var _useParams2 = (0, _reactRouter.useParams)(),
    category = _useParams2.category;
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Navigate, {
    replace: true,
    to: "".concat(baseUrl, "?category=").concat(category)
  });
};
NavigateToListingsWithNewFilter.propTypes = {
  baseUrl: _propTypes.default.string
};
function mapStateToProps(_ref3) {
  var baseUrl = _ref3.baseUrl,
    meta = _ref3.meta,
    userPrefs = _ref3.userPrefs,
    nuiPage = _ref3.nuiPage;
  return {
    baseUrl: baseUrl,
    meta: meta,
    userPrefs: userPrefs,
    nuiPage: nuiPage
  };
}
var RRWrapperChooser = (0, _reactRedux.connect)(mapStateToProps)((0, _withRouter.withRouter)(WrapperChooser));
var commonWrapperRoute = function commonWrapperRoute(baseUrl) {
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    element: /*#__PURE__*/_react.default.createElement(RRWrapperChooser, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    element: /*#__PURE__*/_react.default.createElement(_App.default, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    element: /*#__PURE__*/_react.default.createElement(_Header.default, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl),
    element: /*#__PURE__*/_react.default.createElement(_listings.default, null),
    key: "Listings"
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl, "/listings/:id"),
    element: /*#__PURE__*/_react.default.createElement(_listing.default, null),
    key: "Listing"
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl, "/listings/:id/:name"),
    element: /*#__PURE__*/_react.default.createElement(NavigateToNewListing, {
      baseUrl: baseUrl
    }),
    key: "listingRedirect"
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl, "/listing/:id/:name"),
    element: /*#__PURE__*/_react.default.createElement(NavigateToNewListing, {
      baseUrl: baseUrl
    }),
    key: "listingRedirect2"
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl, "/category/:category"),
    element: /*#__PURE__*/_react.default.createElement(NavigateToListingsWithNewFilter, {
      baseUrl: baseUrl
    }),
    key: "Category"
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl, "/search/:term"),
    element: /*#__PURE__*/_react.default.createElement(_SearchContainer.default, null),
    key: "Search"
  }), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl, "/help"),
    element: /*#__PURE__*/_react.default.createElement(_HelpContainer.default, null),
    key: "Help"
  })), /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    path: "".concat(baseUrl, "/terms/:name"),
    element: /*#__PURE__*/_react.default.createElement(_TermsPage.default, null),
    key: "Terms"
  }), _config.default.cookie_consent ? /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    exact: true,
    path: "".concat(baseUrl, "/cookieconsent"),
    element: /*#__PURE__*/_react.default.createElement(_CookieConsent.default, null),
    key: "CookieConsent"
  }) : null));
};
var publicRoute = function publicRoute(baseUrl) {
  return /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
    handle: {
      isAnonymous: true,
      disableFloorplans: true
    }
  }, commonWrapperRoute(baseUrl));
};
var _default = exports.default = /*#__PURE__*/_react.default.createElement(_reactRouter.Route, {
  getResponseHeaders: function getResponseHeaders() {
    return {
      'X-Frame-Options': 'SAMEORIGIN'
    };
  }
}, commonWrapperRoute(_config.default.nui.baseUrl), publicRoute(ROUTES.US_PUBLIC), publicRoute(ROUTES.EU_PUBLIC));